import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createPinia } from 'pinia'
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { i18nVue } from "laravel-vue-i18n";
import * as Sentry from "@sentry/vue";

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const page = JSON.parse(el.dataset.page);
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(pinia)
            .use(i18nVue, {
                lang: page.props?.locale || page.props?.auth?.user?.settings?.language,
                fallbackLang: 'en',
                resolve: async lang => {
                    const langs = import.meta.glob('../../lang/*.json');
                    return await langs[`../../lang/${lang}.json`]();
                }
            });

        // Initialize Sentry for error tracking
        // Disable Sentry in development environment
        if (!import.meta.env.DEV && process.env.NODE_ENV !== 'development') {
            Sentry.init({
                app,
                dsn: "https://9731916b9619145fe7f9cc161b4629e3@o4509526410067968.ingest.us.sentry.io/4509526412951552",
                environment: import.meta.env.SENTRY_ENVIRONMENT || "development",
                sendDefaultPii: true,
                integrations: [
                    Sentry.replayIntegration()
                ],
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0
            });
        }

        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
